import React from 'react'

import { cn } from '@ps/ds/lib/utils'
import {
  Accordion as ShadAccordion,
  AccordionContent as ShadAccordionContent,
  AccordionItem as ShadAccordionItem,
  AccordionTrigger as ShadAccordionTrigger,
} from '@ps/ds/ui/accordion'
import { ChevronDown } from 'lucide-react'

export type AccordionProps = React.ComponentPropsWithoutRef<typeof ShadAccordion>

export type AccordionItemProps = React.ComponentPropsWithoutRef<typeof ShadAccordionItem>

export type AccordionTriggerProps = React.ComponentPropsWithoutRef<typeof ShadAccordionTrigger>

export type AccordionContentProps = React.ComponentPropsWithoutRef<typeof ShadAccordionContent>

const Accordion = ShadAccordion
Accordion.displayName = 'Accordion'

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof ShadAccordionItem>,
  AccordionItemProps
>(({ ...props }, ref) => {
  return <ShadAccordionItem ref={ref} {...props} />
})
AccordionItem.displayName = 'AccordionItem'

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof ShadAccordionTrigger>,
  AccordionTriggerProps
>(({ children, className, ...props }, ref) => {
  return (
    <ShadAccordionTrigger
      className={cn(
        'flex flex-1 items-center justify-between py-4 font-bold transition-all [&[data-state=open]>svg]:rotate-180',
        className,
      )}
      ref={ref}
      {...props}>
      {children}
      <ChevronDown className="h-5 w-5 shrink-0 text-primary transition-transform duration-200" />
    </ShadAccordionTrigger>
  )
})
AccordionTrigger.displayName = 'AccordionTrigger'

const AccordionCustomTrigger = React.forwardRef<
  React.ElementRef<typeof ShadAccordionTrigger>,
  AccordionTriggerProps
>(({ children, className, ...props }, ref) => {
  return (
    <ShadAccordionTrigger
      className={cn(
        'flex flex-1 p-0 transition-all [&[data-state=open]>svg]:rotate-180',
        className,
      )}
      ref={ref}
      {...props}>
      {children}
    </ShadAccordionTrigger>
  )
})
AccordionCustomTrigger.displayName = 'AccordionCustomTrigger'

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof ShadAccordionContent>,
  AccordionContentProps
>(({ ...props }, ref) => {
  return <ShadAccordionContent ref={ref} {...props} />
})
AccordionContent.displayName = 'AccordionContent'

export { Accordion, AccordionItem, AccordionTrigger, AccordionCustomTrigger, AccordionContent }
